import React from 'react';

import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

//Componentes auxiliares:
import UserRow from './auxiliars/UserRow';
import CustomCard from './auxiliars/CustomCard';
import UserCreationModal from './auxiliars/UserCreationModal';

//Estilos base:
let headerBaseStyles = { textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" };

let UsersProfileManager = (props) => {
    return (
        <CustomCard title="Administración de usuarios">
            <Row style={{ marginBottom: 15 }}>
                <Col xs="1" md="1" lg="1" xl="1" />

                <Col xs="5" md="5" lg="5" xl="5" style={{ textAlign: "left" }}>
                    <p style={{ fontSize: 10, marginBottom: 0, textTransform: "uppercase", fontWeight: "bold" }}>
                        Correo electrónico
                        </p>
                </Col>

                <Col xs="6" md="6" lg="6" xl="6" >
                    <Row>
                        <Col className="text-center" xs="4" md="4" lg="4" xl="4" style={{ ...headerBaseStyles }}>
                            <p style={{ fontSize: 10, marginBottom: 0, textTransform: "uppercase", fontWeight: "bold" }}>
                                Admin
                                </p>
                        </Col>
                        <Col className="text-center" xs="4" md="4" lg="4" xl="4" style={{ ...headerBaseStyles }}>
                            <p style={{ fontSize: 10, marginBottom: 0, textTransform: "uppercase", fontWeight: "bold" }}>
                                Staff
                                </p>
                        </Col>
                        <Col className="text-center" xs="4" md="4" lg="4" xl="4" style={{ ...headerBaseStyles }}>
                            <p style={{ fontSize: 10, marginBottom: 0, textTransform: "uppercase", fontWeight: "bold" }}>
                                Lector
                                </p>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <ul className="list-unstyled team-members">
                {getUsersRows(props)}
            </ul>

            {getUserCreationTools(props)}
        </CustomCard>
    );
}

let getUserCreationTools = (props) => {
    if (props.activeUser.is_admin) {
        return (<UserCreationModal reloadUsersFunction={props.reloadUsersFunction} />);
    }
}

let getUsersRows = (props) => {
    let usersRows = [];
    let users = props.users || [];
    users = users.sort((a, b) => a.email > b.email ? 1 : b.email > a.email ? -1 : 0);

    users.forEach((user, i) => {
        usersRows.push(
            <UserRow
                targetUser={user}
                deleteUserFunction={props.deleteUserFunction}
                updateUserFunction={props.updateUserFunction}
                key={"user." + i + "." + (new Date()).getSeconds()} />
        );
    });

    return usersRows;
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost
    };
};

export default connect(mapStateToProps)(UsersProfileManager);